export default __webpack_public_path__ + "static/visa-lon-nytt-satt-b118f7c960f6f554fbdc8903bfca3517.jpg";